const colorsPreset = {
  // Content colors
  "--content-base": "#FFFFFF",
  "--content-soft": "#958ED8",
  "--content-disabled": "#59549F",
  // Informative colors
  "--informative-base": "#23B4C9",
  "--informative-50": "#ECFEFF",
  "--informative-100": "#CFFAFE",
  "--informative-200": "#A5F3FC",
  "--informative-300": "#67E8F9",
  "--informative-400": "#22D3EE",
  "--informative-500": "#06B6D4",
  "--informative-600": "#0891B2",
  "--informative-700": "#0E7490",
  "--informative-800": "#155E75",
  "--informative-900": "#164E63",
  "--informative-950": "#083344",
  // Warning colors
  "--warning-base": "#D67D39",
  "--warning-soft": "#A65028",
  "--warning-soft2": "#E8BC89",
  "--warning-strong": "#E8BC89",
  "--warning-bold": "#F9EDDB",
  "--warning-subtle": "#6C3722",
  "--warning-50": "#FCF7F0",
  "--warning-100": "#F9EDDB",
  "--warning-200": "#F1D7B7",
  "--warning-300": "#E8BC89",
  "--warning-400": "#E09F64",
  "--warning-500": "#D67D39",
  "--warning-600": "#C8672E",
  "--warning-700": "#A65028",
  "--warning-800": "#854027",
  "--warning-900": "#6C3722",
  "--warning-950": "#3A1A10",
  // Error colors
  "--error-base": "#EF4444",
  "--error-soft": "#B91C1C",
  "--error-strong": "#FCA5A5",
  "--error-bold": "#FEE2E2",
  "--error-subtle": "#7F1D1D",
  "--error-50": "#FEF2F2",
  "--error-100": "#FEE2E2",
  "--error-200": "#FECACA",
  "--error-300": "#FCA5A5",
  "--error-400": "#F87171",
  "--error-500": "#EF4444",
  "--error-600": "#DC2626",
  "--error-700": "#B91C1C",
  "--error-800": "#991B1B",
  "--error-900": "#7F1D1D",
  "--error-950": "#450A0A",
  // Success colors
  "--success-base": "#15A462",
  "--success-soft": "#14814F",
  "--success-strong": "#85F0BE",
  "--success-bold": "#DCFCEC",
  "--success-subtle": "#135438",
  "--success-50": "#F0FDF6",
  "--success-100": "#DCFCEC",
  "--success-200": "#BAF8DA",
  "--success-300": "#85F0BE",
  "--success-400": "#49DF99",
  "--success-500": "#21C97B",
  "--success-600": "#15A462",
  "--success-700": "#14814F",
  "--success-800": "#156642",
  "--success-900": "#135438",
  "--success-950": "#052E1D",
  // Dark Brand colors
  "--darkBrand-50": "#EBE9FF",
  "--darkBrand-100": "#CCCDFF",
  "--darkBrand-200": "#B3ACEF",
  "--darkBrand-300": "#958ED8",
  "--darkBrand-400": "#8E89D1",
  "--darkBrand-500": "#59549F",
  "--darkBrand-600": "#45408D",
  "--darkBrand-700": "#312D6F",
  "--darkBrand-800": "#231F55",
  "--darkBrand-900": "#151240",
  "--darkBrand-950": "#0C0629",
  // Accent Brand colors
  "--accentBrand-50": "#F3F3FF",
  "--accentBrand-100": "#EAE9FE",
  "--accentBrand-200": "#D5D5FF",
  "--accentBrand-300": "#B7B4FE",
  "--accentBrand-400": "#9389FC",
  "--accentBrand-500": "#7059F9",
  "--accentBrand-600": "#562EF0",
  "--accentBrand-700": "#4E24DD",
  "--accentBrand-800": "#411EB9",
  "--accentBrand-900": "#1F0E67",
  "--accentBrand-950": "#371B97",
  // Brand colors
  "--brand-50": "#FAF5FF",
  "--brand-100": "#F2E8FF",
  "--brand-200": "#E7D5FF",
  "--brand-300": "#D4B3FF",
  "--brand-400": "#BA83FD",
  "--brand-500": "#9D4EF8",
  "--brand-600": "#8A32EB",
  "--brand-700": "#7621CF",
  "--brand-800": "#6420A9",
  "--brand-900": "#531B88",
  "--brand-950": "#360665",
  // Stroke colors
  "--stroke-base": "#312D6F",
  "--stroke-soft": "#231F55",
  "--stroke-strong": "#59549F",
  "--stroke-error": "#EF4444",
  // Common Alpha colors
  "--commonAlpha-base": "#FFFFFF66",
  "--commonAlpha-soft": "#FFFFFF1A",
  "--commonAlpha-softer": "#FFFFFF0A",
  "--commonAlpha-inverseBase": "#00000066",
  "--commonAlpha-inverseStrong": "#00000099",
  // Refer Balls colors
  "--referBalls-basket1BgStart": "#FBBF24",
  "--referBalls-basket1BgStop": "#FBBF24",
  "--referBalls-basket1Label": "#FBBF24",
  "--referBalls-basket2BgStart": "#E09F64",
  "--referBalls-basket2BgStop": "#E09F64",
  "--referBalls-basket2Label": "#E09F64",
  "--referBalls-basket3BgStart": "#8A32EB",
  "--referBalls-basket3BgStop": "#8A32EB",
  "--referBalls-basket3Label": "#BA83FD",
  "--referBalls-basket4BgStart": "#00BCFF",
  "--referBalls-basket4BgStop": "#00BCFF",
  "--referBalls-basket4Label": "#00BCFF",
  "--referBalls-basket5BgStart": "#59549F",
  "--referBalls-basket5BgStop": "#59549F",
  "--referBalls-basket5Label": "#B8AEDA",
  "--referBalls-basketNormalBgStart": "#45408D",
  "--referBalls-basketNormalBgStop": "#45408D",
  "--referBalls-basketNormalLabel": "#8E89D1",
  // Background Images
  "--bg-header": "radial-gradient(133.74% 100.44% at 100% 50%, #231F55 0%, #151240 100%)",
  "--bg-dialog": "radial-gradient(51.67% 51.19% at 51.67% 0%, #312D6F 0%, #151240 100%)",
  "--bg-homeBtn": "linear-gradient(180deg, #312D6F 0%, #231F55 50.48%, #312D6F 100%)",
  "--bg-grdPrimary": "radial-gradient(50% 100% at 50% 0%, #7059F9 0%, #4E24DD 100%)",
  "--bg-grdPrimaryAlt": "linear-gradient(180deg, #371B97 0%, #411EB9 100%)",
  "--bg-grdSecondary": "radial-gradient(50% 100% at 50% 0%, #312D6F 0%, #231F55 100%)",
  "--bg-grdSecondaryAlt": "linear-gradient(180deg, #312D6F 0%, #45408D 100%)",
  "--bg-bottomMenu": "radial-gradient(33.48% 103.75% at 52.2% 0%, #531B88 0%, #151240 100%)",
  "--bg-bottomNavBtnRound": "linear-gradient(180deg,#9C40FF 0%,#3C39A8 100%)",
  "--bg-bottomNavBtnRoundRimLight": "radial-gradient(46.67% 23.33% at 50% 100%, rgba(114, 187, 255, 0.80) 0%, rgba(75, 69, 234, 0.00) 100%)",
  "--bg-bottomNavBtnIndicatorActive": "radial-gradient(44.58% 50% at 50% 100%,rgba(109,93,255,0.60) 0%,rgba(42,28,91,0.00) 100%)",
  "--bg-bottomNavBtnIndicator": "",
  "--bg-pageTitle": "linear-gradient(180deg, #FFF 19.11%, #B3ACEF 71.43%)",
  "--bg-gradientTextBase": "linear-gradient(180deg, #FFF 19.11%, #B3ACEF 71.43%)",
  "--bg-tabNavSecondary": "linear-gradient(180deg,#312D6F 0%,#231F55 100%)",
  "--bg-referFriendTopSection": "radial-gradient(73.33% 38.02% at 73.33% 58.07%, #371b9799 0%, rgba(0, 0, 0, 0.00) 100%)",
  "--bg-progressBarTray": "linear-gradient(180deg, #151240 0%, #231F55 100%)",
  "--bg-timerProgressBar": "linear-gradient(90deg, #7621CF 0%, #F59E0B 70%, #FCD34D 100%)",
  "--bg-timerProgressStripes": "linear-gradient(-45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent)",
  "--bg-card": "radial-gradient(46.81% 58.96% at 50% 0%,#333230 0%,#151240 100%)",
  "--bg-flipClock": "linear-gradient(180deg, #45408D 0%, #312D6F 42%, #231F55 46.5%, #151240 100%)",
  "--bg-grdHigh": "radial-gradient(71.88% 55.56% at 50% 0%, theme('backgroundColor.gradientTopHigh') 0%, theme('backgroundColor.gradientBottomHigh') 100%)",
  "--bg-grdMid": "radial-gradient(69.19% 53.57% at 50% 0%, theme('backgroundColor.gradientTopMid') 0%, theme('backgroundColor.gradientBottomMid') 100%)",
  "--bg-grdLow": "radial-gradient(69.19% 53.57% at 50% 0%, theme('backgroundColor.gradientTopLow') 0%, theme('backgroundColor.gradientBottomLow') 100%)",
  // Play and Spin background images
  "--bg-playAndSpinOverlay": "linear-gradient(270deg, rgba(31, 27, 79, 0.00) 0%, #1F1B4F 100%)",
  "--bg-playAndSpinItemEmpty": "linear-gradient(90deg, rgba(var(--darkBrand-800) / 0.00) 0%, rgba(var(--darkBrand-800)) 51.5%, rgba(var(--darkBrand-800)/ 0.00) 100%)",
  // Background Colors
  "--bg-backdrop": "#0C0629D9",
  "--bg-overlay": "#000000CC",
  "--bg-solidLow": "#141129",
  "--bg-gradientTopLow": "#1F0E67",
  "--bg-gradientBottomLow": "#141129",
  "--bg-solidMid": "#1C1440",
  "--bg-gradientTopMid": "#32276D",
  "--bg-gradientBottomMid": "#1A1536",
  "--bg-solidHigh": "#32276D",
  "--bg-gradientTopHigh": "#32276D",
  "--bg-gradientBottomHigh": "#21174C",
  // Text Stylish Colors
  "--textStylish-strongGrdFrom": "#FBBF24",
  "--textStylish-strongGrdMid": "#d69d9d",
  "--textStylish-strongGrdTo": "#BA83FD"
};
const themePurpleStardust = {
  id: "purple-stardust",
  name: "Purple Stardust",
  className: "purple-stardust",
  colors: colorsPreset
};
export {
  colorsPreset,
  themePurpleStardust
};
